module.exports = __webpack_public_path__ + "img/QuicklyImport.227d81a3.svg";